export default [
  {title: '姓名',dataIndex: 'idInfo.name'},
  {title: '证件号',dataIndex: 'idInfo.certNo'},
  {title: '设备SN',dataIndex: 'deviceInfo.deviceSn'},
  {title: '设备类型',dataIndex: 'deviceInfo.deviceType',scopedSlots: { customRender: 'deviceType'}},
  {title: '所属行业',dataIndex: 'deviceInfo.industryName'},
  {title: '支付宝酒店',dataIndex: 'deviceInfo.zfbHotelProjectName'},
  {title: '业务平台',dataIndex: 'notifyResults',scopedSlots: { customRender: 'notifyResults'}},
  {title: '核验时间',dataIndex: 'operateAt'},
]
